<template>
  <div class="flex">
    <el-date-picker
      ref="refDatePicker"
      v-model="datePicker"
      class="comp-main"
      :style="{ width }"
      size="mini"
      :type="type"
      unlink-panels
      range-separator="至"
      :placeholder="placeholder"
      :start-placeholder="startPlaceholder"
      :end-placeholder="endPlaceholder"
      :format="format"
      :value-format="valueFormat"
      :picker-options="pickerOptions"
      :disabled="disabled"
      :clearable="clearable"
      @change="change"
      @blur="blur"
    />
    <div v-if="isShowFast" class="m-l-5">
      <el-button-group size="mini">
        <el-button
          v-for="(item, index) in fastDateList"
          :key="index"
          :type="isActiveFast(item) ? 'primary' : 'default'"
          size="mini"
          @click="fastItemClick(item)"
        >
          {{ item.text }}
        </el-button>
      </el-button-group>
    </div>
  </div>
</template>

<script>
let daySeconds = 1000 * 60 * 60 * 24 // 一天秒数 86400000
export default {
  props: {
    type: {
      type: String,
      default: 'daterange'
    },
    value: {
      type: [String, Array],
      default: () => {
        return []
      }
    },
    format: {
      type: String,
      default: 'yyyy-MM-dd' // 显示格式
    },
    valueFormat: {
      type: String,
      default: 'yyyy-MM-dd' // 提交格式
    },
    width: {
      type: String,
      default: '170px'
    },
    fontSize: {
      type: String,
      default: '12px'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disabledDate: {
      type: String,
      default: ''
    },
    clearable: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    isShowFast: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fastDateList: []
    }
  },
  computed: {
    pickerOptions() {
      let result = {}
      // 快捷选项
      let shortcuts = [
        {
          text: '昨天',
          onClick: (picker) => {
            let now = new Date()
            let start = new Date(now.getTime() - daySeconds * 1)
            let end = new Date(now.getTime() - daySeconds * 1)

            let result = [start, end]
            picker.$emit('pick', result)
          }
        },
        {
          text: '今天',
          onClick: (picker) => {
            let now = new Date()
            let start = new Date()

            let result = [start, now]
            picker.$emit('pick', result)
          }
        },
        {
          text: '本周',
          onClick: (picker) => {
            let now = new Date()
            let week = now.getDay() // 周 一~日 1~7
            let start = new Date(now.getTime() + daySeconds * (1 - week))
            let end = new Date(now.getTime() + daySeconds * (7 - week))

            let result = [start, end]
            picker.$emit('pick', result)
          }
        },
        {
          text: '上周',
          onClick: (picker) => {
            let now = new Date()
            let week = now.getDay() // 周 一~日 1~7
            let start = new Date(now.getTime() + daySeconds * (1 - week - 7))
            let end = new Date(now.getTime() + daySeconds * (7 - week - 7))

            let result = [start, end]
            picker.$emit('pick', result)
          }
        },
        {
          text: '本月',
          onClick: (picker) => {
            let start = new Date()
            start.setDate(1)

            let end = new Date()
            end.setMonth(end.getMonth() + 1) // 先设置为下一个月
            end.setDate(0) // 再设置本月第0天，即上一个月的最后一天

            let result = [start, end]
            picker.$emit('pick', result)
          }
        },
        {
          text: '上月',
          onClick: (picker) => {
            let start = new Date()
            start.setMonth(start.getMonth() - 1) // 先设置为上一个月
            start.setDate(1)

            let end = new Date()
            end.setDate(0) // 设置本月第0天，即上一个月的最后一天

            let result = [start, end]
            picker.$emit('pick', result)
          }
        },
        {
          text: '今年',
          onClick: (picker) => {
            let now = new Date()
            let start = new Date(now.getFullYear(), 0, 1)
            let end = new Date(now.getFullYear(), 11, 31)

            let result = [start, end]
            picker.$emit('pick', result)
          }
        },
        {
          text: '上年',
          onClick: (picker) => {
            let now = new Date()
            let start = new Date(now.getFullYear() - 1, 0, 1)
            let end = new Date(now.getFullYear() - 1, 11, 31)

            let result = [start, end]
            picker.$emit('pick', result)
          }
        },
        {
          text: '近7天',
          onClick: (picker) => {
            let now = new Date()
            let start = new Date(now.getTime() - daySeconds * 6)

            let result = [start, now]
            picker.$emit('pick', result)
          }
        },
        {
          text: '近30天',
          onClick: (picker) => {
            let now = new Date()
            let start = new Date(now.getTime() - daySeconds * 29)

            let result = [start, now]
            picker.$emit('pick', result)
          }
        },
        {
          text: '近90天',
          onClick: (picker) => {
            let now = new Date()
            let start = new Date(now.getTime() - daySeconds * 89)

            let result = [start, now]
            picker.$emit('pick', result)
          }
        },
        {
          text: '近365天',
          onClick: (picker) => {
            let now = new Date()
            let start = new Date(now.getTime() - daySeconds * 364)

            let result = [start, now]
            picker.$emit('pick', result)
          }
        },
        {
          text: '近5年',
          onClick: (picker) => {
            let now = new Date()
            let start = new Date(now.getTime() - daySeconds * 1825)

            let result = [start, now]
            picker.$emit('pick', result)
          }
        },
        {
          text: '全部',
          onClick: (picker) => {
            let result = []
            picker.$emit('pick', result)
          }
        },
        // {
        //   text: '近10年',
        //   onClick: (picker) => {
        //     let now = new Date()
        //     let start = new Date(now.getTime() - daySeconds * 3652)

        //     let result = [start, now]
        //     picker.$emit('pick', result)
        //   }
        // },
        {
          text: '1月',
          onClick: (picker) => {
            let start = new Date()
            start.setMonth(0)
            start.setDate(1)

            let end = new Date()
            end.setMonth(1)
            end.setDate(0)

            let result = [start, end]
            picker.$emit('pick', result)
          }
        },
        {
          text: '2月',
          onClick: (picker) => {
            let start = new Date()
            start.setMonth(1)
            start.setDate(1)

            let end = new Date()
            end.setMonth(2)
            end.setDate(0)

            let result = [start, end]
            picker.$emit('pick', result)
          }
        },
        {
          text: '3月',
          onClick: (picker) => {
            let start = new Date()
            start.setMonth(2)
            start.setDate(1)

            let end = new Date()
            end.setMonth(3)
            end.setDate(0)

            let result = [start, end]
            picker.$emit('pick', result)
          }
        },
        {
          text: '4月',
          onClick: (picker) => {
            let start = new Date()
            start.setMonth(3)
            start.setDate(1)

            let end = new Date()
            end.setMonth(4)
            end.setDate(0)

            let result = [start, end]
            picker.$emit('pick', result)
          }
        },
        {
          text: '5月',
          onClick: (picker) => {
            let start = new Date()
            start.setMonth(4)
            start.setDate(1)

            let end = new Date()
            end.setMonth(5)
            end.setDate(0)

            let result = [start, end]
            picker.$emit('pick', result)
          }
        },
        {
          text: '6月',
          onClick: (picker) => {
            let start = new Date()
            start.setMonth(5)
            start.setDate(1)

            let end = new Date()
            end.setMonth(6)
            end.setDate(0)

            let result = [start, end]
            picker.$emit('pick', result)
          }
        },
        {
          text: '7月',
          onClick: (picker) => {
            let start = new Date()
            start.setMonth(6)
            start.setDate(1)

            let end = new Date()
            end.setMonth(7)
            end.setDate(0)

            let result = [start, end]
            picker.$emit('pick', result)
          }
        },
        {
          text: '8月',
          onClick: (picker) => {
            let start = new Date()
            start.setMonth(7)
            start.setDate(1)

            let end = new Date()
            end.setMonth(8)
            end.setDate(0)

            let result = [start, end]
            picker.$emit('pick', result)
          }
        },
        {
          text: '9月',
          onClick: (picker) => {
            let start = new Date()
            start.setMonth(8)
            start.setDate(1)

            let end = new Date()
            end.setMonth(9)
            end.setDate(0)

            let result = [start, end]
            picker.$emit('pick', result)
          }
        },
        {
          text: '10月',
          onClick: (picker) => {
            let start = new Date()
            start.setMonth(9)
            start.setDate(1)

            let end = new Date()
            end.setMonth(10)
            end.setDate(0)

            let result = [start, end]
            picker.$emit('pick', result)
          }
        },
        {
          text: '11月',
          onClick: (picker) => {
            let start = new Date()
            start.setMonth(10)
            start.setDate(1)

            let end = new Date()
            end.setMonth(11)
            end.setDate(0)

            let result = [start, end]
            picker.$emit('pick', result)
          }
        },
        {
          text: '12月',
          onClick: (picker) => {
            let start = new Date()
            start.setMonth(11)
            start.setDate(1)

            let end = new Date()
            end.setMonth(12)
            end.setDate(0)

            let result = [start, end]
            picker.$emit('pick', result)
          }
        }
      ]

      if (this.type === 'daterange' || this.type === 'datetimerange') {
        result.shortcuts = this.$util.deepCopy(shortcuts)
      }

      // 禁止选择某部分日期
      if (this.type === 'date' && this.disabledDate) {
        result.disabledDate = (time) => {
          let today = new Date()
          today.setHours(0, 0, 0, 0) // 设置为今天0点
          let isNext = time.getTime() >= today.getTime() // 设置禁止大于或等于今天
          return this.disabledDate === 'next' ? isNext : !isNext
        }
      }

      return result
    },
    datePicker: {
      get() {
        return this.value
      },
      set(val = ['', '']) {
        let result = this.$util.deepCopy(val)
        this.$emit('update:value', result)
      }
    },
    startPlaceholder() {
      return this.type === 'daterange' ? '开始日期' : '开始时间'
    },
    endPlaceholder() {
      return this.type === 'daterange' ? '结束日期' : '结束时间'
    },
    isShowClose() {
      return this.clearable ? 'block' : 'none'
    },
    inputWidth() {
      let result = this.type === 'date' || this.type === 'daterange'
      return result ? '64px' : '112px'
    }
  },
  mounted() {
    if (this.isShowFast) {
      this.setPickerPanel()
      this.getFastList()
    }
  },
  methods: {
    /**
     * 快速日期模式挂载时初始化 picker 面板状态
     * 设计意图：必须触发 focus 才能让 el-date-picker 初始化内部 picker 实例，
     *          否则快捷按钮（fastItemClick）调用 refDatePicker.picker 时拿不到实例或状态为空导致数据不更新。
     * 优化点：
     * 1）无论 value 是否为空都必须执行 focus，以完成 picker 内部初始化
     * 2）value 有值时，走原有 inputs focus + 模拟 Enter 确认值的逻辑，让面板正常关闭
     * 3）value 为空时，模拟 Enter 无法确认任何内容导致面板不关闭，
     *    → 跳过 Enter 模拟，直接执行 blur + 显式隐藏 el-picker-panel，确保面板被强制收起
     * 4）统一在最后追加 blur 与 DOM 隐藏兜底，保证所有场景下面板不会残留
     */
    setPickerPanel() {
      if (!this.$refs.refDatePicker) return
      // 无论空值/非空都必须 focus：让 picker 完成内部 picker 实例初始化，供快捷按钮 onClick 使用
      this.$refs.refDatePicker.focus()

      // 判断是否为有值场景
      const hasValue = this.value && Array.isArray(this.value) && this.value.length > 0

      this.$nextTick(() => {
        const inputs = document.querySelectorAll('.el-date-editor input')

        if (hasValue) {
          // ===== 非空值场景：按原逻辑定位结束输入框并模拟 Enter 确认，触发内部确认与关闭 =====
          if (inputs && inputs.length) inputs[inputs.length - 1].focus()
          const keyEventData = {
            key: 'Enter',
            code: 'Enter',
            keyCode: 13,
            which: 13,
            bubbles: true,
            cancelable: true
          }
          const enterDownEvent = new KeyboardEvent('keydown', keyEventData) // 创建 Enter 键按下事件
          const enterUpEvent = new KeyboardEvent('keyup', keyEventData) // 创建 Enter 键释放事件
          const activeElement = document.activeElement // 在当前活动元素上触发
          if (activeElement) {
            activeElement.dispatchEvent(enterDownEvent)
            setTimeout(() => {
              activeElement.dispatchEvent(enterUpEvent)
            }, 30)
          }
        }

        // ===== 无论空值/非空最后统一执行收起兜底 =====
        setTimeout(
          () => {
            try {
              // 1) el-date-picker 实例 blur，让其按正常失焦逻辑关闭面板
              if (this.$refs.refDatePicker && typeof this.$refs.refDatePicker.blur === 'function') {
                this.$refs.refDatePicker.blur()
              }
              // 2) 当前活动元素 blur，移除焦点
              if (document.activeElement && typeof document.activeElement.blur === 'function') {
                document.activeElement.blur()
              }
              // 3) 极端兜底：直接隐藏所有 el-picker-panel，确保面板 DOM 不会残留展开
              const panels = document.querySelectorAll('.el-picker-panel')
              panels.forEach((panel) => {
                if (panel && panel.style) panel.style.display = 'none'
              })
            } catch (e) {
              // 静默忽略 DOM 操作异常，避免影响主流程
            }
          },
          hasValue ? 120 : 50
        )
      })
    },
    getFastList() {
      let result = []
      let textList = ['今天', '昨天', '本周', '上周', '本月', '上月', '今年', '全部']
      textList.forEach((itemSt) => {
        this.pickerOptions.shortcuts.forEach((itemNd) => {
          if (itemNd.text === itemSt) {
            let obj = this.$util.deepCopy(itemNd)
            result.push(obj)
          }
        })
      })
      this.fastDateList = result
    },
    fastItemClick(val) {
      this.$nextTick(() => {
        let refDatePicker = this.$refs.refDatePicker
        val.onClick(refDatePicker.picker)
        this.change()
      })
    },
    isActiveFast(item) {
      try {
        let picked
        const fakePicker = {
          $emit(event, val) {
            if (event === 'pick') picked = val
          }
        }
        // call the shortcut onClick to get its pick result
        if (typeof item.onClick === 'function') item.onClick(fakePicker)

        const dp = this.datePicker || []

        // both empty -> match (代表 全部)
        const isEmptyPicked = !picked || !picked.length
        const isEmptyDp = !dp || !dp.length
        if (isEmptyPicked && isEmptyDp) return true
        if (isEmptyPicked || isEmptyDp) return false

        const toYMD = (v) => {
          if (!v && v !== 0) return null
          if (typeof v === 'string') return v.slice(0, 10)
          if (v instanceof Date) {
            const y = v.getFullYear()
            const m = String(v.getMonth() + 1).padStart(2, '0')
            const d = String(v.getDate()).padStart(2, '0')
            return `${y}-${m}-${d}`
          }
          try {
            const dt = new Date(v)
            if (isNaN(dt.getTime())) return null
            const y = dt.getFullYear()
            const m = String(dt.getMonth() + 1).padStart(2, '0')
            const d = String(dt.getDate()).padStart(2, '0')
            return `${y}-${m}-${d}`
          } catch (e) {
            return null
          }
        }

        const a = picked.map((x) => toYMD(x))
        const b = (Array.isArray(dp) ? dp : []).map((x) => toYMD(x))
        if (a.length !== b.length) return false
        for (let i = 0; i < a.length; i++) {
          if (a[i] !== b[i]) return false
        }
        return true
      } catch (e) {
        return false
      }
    },
    change() {
      this.$emit('change')
    },
    blur() {
      this.$emit('blur')
    }
  }
}
</script>

<style lang="less" scoped>
.comp-main {
  // padding: 3px 5px;
  /deep/ .date-fast {
    display: flex;
    align-items: center;
  }
  /deep/ .el-range-editor--mini .el-range-separator {
    font-size: v-bind(fontSize);
    line-height: 18px;
  }
  /deep/ .el-range__close-icon {
    display: v-bind(isShowClose);
  }
  /deep/ .el-range-separator {
    width: auto;
    height: auto;
    padding: 0 2px;
    // line-height: 16px;
    font-size: v-bind(fontSize);
  }
  /deep/ .el-range-input {
    width: v-bind(inputWidth);
    padding-top: 2px;
    font-size: v-bind(fontSize);
    color: @colorGrayDeep;
  }
}
</style>
